import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateSupplierPartController";
import SupplierService from "../../../Supplier/Controller/SupplierController"
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateSupplierPart({ modalInstance, currentSupplierStock, onClose, onSuccess, SupplierList, PartID }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [formData, setFormData] = useState({ FK_Stock_ID: PartID, mon_CostPrice: '0', vc_SupplierCode: '', dec_Quantity: '0', FK_Supplier_ID: 0 });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentSupplierStock) {

            setFormData({
                FK_Stock_ID: PartID, mon_CostPrice: currentSupplierStock.mon_CostPrice, vc_SupplierCode: currentSupplierStock.vc_SupplierCode,
                dec_Quantity: currentSupplierStock.dec_Quantity, SupplierID: currentSupplierStock.FK_Supplier_ID,
                vc_SupplierName: currentSupplierStock.vc_SupplierName, vc_SupplierCode: currentSupplierStock.vc_StockCode
            });
        } else {
            setFormData({
                FK_Stock_ID: PartID, mon_CostPrice: '0', vc_SupplierCode: '', dec_Quantity: '0', FK_Supplier_ID: 0
            }); // Clear form data when switching to add mode
        }
    }, [currentSupplierStock]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        if (currentSupplierStock) {
            formData.ID = currentSupplierStock.ID;
        } else {
            formData.ID = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data

        }, () => {
            onSuccess(); // Call onSuccess to reload data

        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="supplierStockModal" tabIndex="-1" aria-labelledby="supplierStockModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{currentSupplierStock ? "Edit Supplier Stock" : "Add Supplier Stock"}</h5>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginTop": "10px", "marginLeft": "0px", "marginRight": "0" }}>
                                    <label htmlFor="vc_SupplierName" className="col-sm-2 col-form-label">Supplier Name:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" readOnly="true" name="vc_SupplierName" value={formData.vc_SupplierName} onChange={handleFieldChange} />
                                        {errors.vc_SupplierName && <div style={{ color: 'red' }}>{errors.vc_SupplierName}</div>}
                                    </div>
                                    <label htmlFor="vc_SupplierCode" className="col-sm-2 col-form-label">Stock Code:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_SupplierCode" value={formData.vc_SupplierCode} onChange={handleFieldChange} />
                                        {errors.vc_SupplierCode && <div style={{ color: 'red' }}>{errors.vc_SupplierCode}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0" }}>
                                    <label htmlFor="dec_Quantity" className="col-sm-2 col-form-label">Stock Level:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="dec_Quantity" value={formData.dec_Quantity} onChange={handleFieldChange} />
                                        {errors.dec_Quantity && <div style={{ color: 'red' }}>{errors.dec_Quantity}</div>}
                                    </div>
                                    <label htmlFor="mon_CostPrice" className="col-sm-2 col-form-label">Cost Price:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="mon_CostPrice" value={formData.mon_CostPrice} onChange={handleFieldChange} />
                                        {errors.mon_CostPrice && <div style={{ color: 'red' }}>{errors.mon_CostPrice}</div>}
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {currentSupplierStock ? " Update" : " Save"}
                                </button>

                                <button type="button" className="btn btn-danger" onClick={onClose} aria-label="Close">
                                   <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSupplierPart;